import type { AysCodeResponse} from '../code';
import { AysCode, normalizeAvailableYears } from '../code';

interface AysIcdSpecificCodeResponse extends AysCodeResponse {
  content?: boolean;
  ansteckend?: boolean;
  ebmlabor?: boolean;
  rare?: boolean;
  age?: AysIcdCodeAge;
  agereject?: AysIcdCodeInfo;
  morbidity?: AysIcdCodeInfo;
  mortalities?: AysIcdCodeMortalities;
  paragraph295?: AysIcdCodeInfo;
  paragraph301?: AysIcdCodeInfo;
  sexcode?: AysIcdCodeInfo;
  sexreject?: AysIcdCodeInfo;
}

export class AysIcdSpecificCode extends AysCode {
  public static override fromObject(obj: AysCodeResponse): AysIcdSpecificCode {
    const icdObj = obj as AysIcdSpecificCodeResponse;

    return new AysIcdSpecificCode(
      icdObj.name,
      icdObj.description,
      icdObj.year,
      normalizeAvailableYears(icdObj.availableYears),
      icdObj.content,
      icdObj.ansteckend,
      icdObj.ebmlabor,
      icdObj.rare,
      icdObj.age,
      icdObj.agereject,
      icdObj.morbidity,
      icdObj.mortalities,
      icdObj.paragraph295,
      icdObj.paragraph301,
      icdObj.sexcode,
      icdObj.sexreject,
    );
  }

  constructor(
    name: string,
    description: string,
    year: number,
    availableYears?: number[],
    public content?: boolean,
    public ansteckend?: boolean,
    public ebmlabor?: boolean,
    public rare?: boolean,
    public age?: AysIcdCodeAge,
    public agereject?: AysIcdCodeInfo,
    public morbodity?: AysIcdCodeInfo,
    public mortalities?: AysIcdCodeMortalities,
    public paragraph295?: AysIcdCodeInfo,
    public paragraph301?: AysIcdCodeInfo,
    public sexcode?: AysIcdCodeInfo,
    public sexreject?: AysIcdCodeInfo,
  ) {
    super(name, description, 'ICD-10-GM', 'specific', year, availableYears);
  }

  public override clone(): AysIcdSpecificCode {
    return new AysIcdSpecificCode(
      this.name,
      this.description,
      this.year,
      this.availableYears ? [...this.availableYears] : undefined,
      this.content,
      this.ansteckend,
      this.ebmlabor,
      this.rare,
      this.age ? JSON.parse(JSON.stringify(this.age)) : undefined,
      this.agereject ? JSON.parse(JSON.stringify(this.agereject)) : undefined,
      this.morbodity ? JSON.parse(JSON.stringify(this.morbodity)) : undefined,
      this.mortalities
        ? JSON.parse(JSON.stringify(this.mortalities))
        : undefined,
      this.paragraph295
        ? JSON.parse(JSON.stringify(this.paragraph295))
        : undefined,
      this.paragraph301
        ? JSON.parse(JSON.stringify(this.paragraph301))
        : undefined,
      this.sexcode ? JSON.parse(JSON.stringify(this.sexcode)) : undefined,
      this.sexreject ? JSON.parse(JSON.stringify(this.sexreject)) : undefined,
    );
  }
}

export interface AysIcdCodeAge {
  high: string;
  low: string;
}

export interface AysIcdCodeMortalities {
  mort1: AysIcdCodeMortalitiesCode;
  mort2: AysIcdCodeMortalitiesCode;
  mort3: AysIcdCodeMortalitiesCode;
  mort4: AysIcdCodeMortalitiesCode;
}

export interface AysIcdCodeMortalitiesCode {
  code: string;
  description: string;
  category: AysIcdCodeMortalitiesCodeCategory;
}

export interface AysIcdCodeMortalitiesCodeCategory {
  type: string;
  id: number;
  description: string;
}

export interface AysIcdCodeInfo {
  code: string;
  description: string;
}
